import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const SvgSearchMd = ({ ...props }: SvgIconProps) => (
  <SvgIcon {...props}>
    <path
      d="m21 21-4.35-4.35M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
      stroke="currentColor"
      fill="none"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default SvgSearchMd;
